import { Link } from "react-router-dom";
import { Package, ListOrdered, Gauge, PauseCircle, Users } from "lucide-react";
import { Brand } from "../Brand";

export const ADMIN_PAGES = [
  ["orders", "Orders", Package], ["queue", "Print queue", ListOrdered], ["spend-gate", "Spend gate", Gauge], ["held", "Held ducks", PauseCircle],
  ["accounts", "Accounts (view only)", Users],
];

// Staff open /admin: the admin pages they use, the dashboard tiles are for admins and the owner.
export const StaffLanding = () => (
  <div data-testid="admin-staff-landing" className="min-h-screen bg-dots px-6 py-12">
    <main className="mx-auto max-w-2xl">
      <Brand />
      <h1 className="mt-8 font-heading text-4xl font-extrabold tracking-tight">Admin</h1>
      <p className="mt-2 text-sm text-muted-foreground">The dashboard is for admins and the owner. Your pages:</p>
      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        {ADMIN_PAGES.map(([path, label, Icon]) => (
          <Link key={path} to={`/admin/${path}`} data-testid={`admin-landing-${path}`}
            className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 font-semibold transition-colors hover:border-primary">
            <Icon className="h-5 w-5 text-accent" /> {label}
          </Link>
        ))}
      </div>
    </main>
  </div>
);
